module.exports = __webpack_public_path__ + "img/qrcode.f05c563a.png";